export class DownloadFailed extends Error {
  constructor(
    readonly status: number,
    readonly statusText: string,
  ) {
    super(`Downloading the model failed (${status} ${statusText})`)
    this.name = 'DownloadFailed'
  }
}
